module.exports = __webpack_public_path__ + "static/media/feature.d634ea99.jpg";